import { useEffect, useRef, useState } from "react";
import AppConfig from "./AppConfig.json";
import axios from "axios";
import { connect } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import * as actions from "./actions";
import ErrorMessage from "./ErrorMessage";
import PinInput from "react-pin-input";

export function MemberEditEmail({ app, onUpdate }) {
  let { currentUserProfile } = app;
  let history = useHistory();
  const [errorMessage, setErrorMessage] = useState(null);
  let [email, setEmail] = useState("");
  const [verifyOTP, setVerifyOTP] = useState(false);
  const [otpRequestID, setOtpRequestID] = useState(true);
  let [isMismatch, setIsMismatch] = useState(false);
  let pinInput = useRef();

  useEffect(() => {
    setEmail(currentUserProfile.email);
    const interval = setInterval(() => {
      setVerifyOTP((verifyOTP) => (verifyOTP > 0 ? verifyOTP - 1 : verifyOTP));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const formValidate = () => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return email && re.test(email);
  };

  const validateOTP = async (pin) => {
    setIsMismatch(false);

    try {
      let result = await axios.post(
        `${AppConfig.endpoint}/member/otp/verify`,
        { code: pin, otpRequestID },
        {
          headers: {
            "x-access-token": app.accessToken,
            "x-api-key": AppConfig.api_key,
          },
        }
      );

      if (!result.error) {
        if (result.data && result.data.isVerified) {
          sendUpdate();
        } else {
          setIsMismatch(true);
          pinInput.current.clear();
        }
      }
    } catch (err) {
      // history.push("/member/error")
      // setIsMismatch(true)
    }
  };

  const requestOtp = async () => {
    try {
      let result = await axios.post(
        `${AppConfig.endpoint}/member/otp/request`,
        {
          type: "email",
          on: {
            value: email,
          },
        },
        {
          headers: {
            "x-access-token": app.accessToken,
            "x-api-key": AppConfig.api_key,
          },
        }
      );

      if (!result.error) {
        setOtpRequestID(result.data.requestID);
        setVerifyOTP(299); // Timeout 5 min.( 300 sec.)

        setInterval(() => {}, 1000);
      }
    } catch (err) {
      // history.push("/member/error")
      // setIsMismatch(true)
    }
  };

  const sendUpdate = async () => {
    let body = { email };

    let result = await axios.post(
      `${AppConfig.endpoint}/member/update/email`,
      body,
      {
        headers: {
          "x-access-token": app.accessToken,
          "x-api-key": AppConfig.api_key,
        },
      }
    );

    if (result.data.success) {
      history.push("/member/profile");
      onUpdate && onUpdate();
    } else {
      setErrorMessage(result.data);
    }
  };

  return (
    <div className="edit-screen pin-auth-screen">
      {errorMessage && <ErrorMessage title="Error" message={errorMessage} />}
      <div class="section-header">Email</div>
      {verifyOTP === false && (
        <>
          <div className="edit-form">
            <div className="field">
              <label className="label">Email Address</label>
              <div className="control">
                <input
                  className="input"
                  type="text"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>
          </div>

          <div className="screen-footer">
            <button
              className="button is-fullwidth is-save"
              disabled={!formValidate()}
              onClick={() => requestOtp()}
            >
              Continue
            </button>
          </div>
        </>
      )}
      {verifyOTP !== false && (
        <>
          <div style={{ marginBottom: 20 }}>Enter OTP</div>
          <div className="hint" style={{ background: "none", color: "#888" }}>
            Enter OTP sent to your email{" "}
            {email.split("@")[0].slice(0, email.split("@")[0].length / 2)}***@
            {email.split("@")[1]}
          </div>

          <PinInput
            ref={pinInput}
            length={6}
            initialValue=""
            secret={false}
            onChange={(value, index) => {}}
            type="numeric"
            inputMode="number"
            style={{ borderRadius: 8 }}
            inputStyle={{
              height: 48,
              width: 40,
              borderRadius: 8,
              background: "#252525",
              border: 0,
              margin: 4,
              fontSize: 25,
              color: "#FFFFFF",
            }}
            inputFocusStyle={{ background: "#383838", border: 0 }}
            onComplete={(value, index) => {
              validateOTP(value);
            }}
            autoSelect={true}
            regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
          />

          {verifyOTP > 0 && (
            <div className="hint" style={{ background: "none", color: "#888" }}>
              Resend OTP code if it doesn’t arrive in{" "}
              {Math.floor(verifyOTP / 60)}:
              {verifyOTP % 60 > 9 ? verifyOTP % 60 : `0${verifyOTP % 60}`}
            </div>
          )}

          {isMismatch && (
            <div className="help has-text-danger">
              Incorrect OTP. Please try again.
            </div>
          )}
          {verifyOTP <= 0 && (
            <div className="screen-footer">
              <button
                className="button is-fullwidth is-save"
                onClick={() => requestOtp()}
              >
                Resend OTP
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default withRouter(connect((state) => state, actions)(MemberEditEmail));
